import {Component,computed,inject,OnInit, signal, ViewChild, WritableSignal } from '@angular/core';
import {MatTabsModule} from '@angular/material/tabs';
import { NotificationService } from '../../services/notificationservice';
import { GeneratorsComponent } from './generators/generators.component';
import { StreamsComponent } from './streams/streams.component';
import { PricematrixComponent } from './pricematrix/pricematrix.component';
import { TotepricematrixComponent } from './totepricematrix/totepricematrix.component';
import { LabdataComponent } from './labdata/labdata.component';
import { FilterControlComponent, FilterKey } from "../shared/components/filter-control/filter-control.component";
import { FilterState } from '../../interfaces/generatorsmodel';
import { MatDialog } from '@angular/material/dialog';
import { AddeditGeneratorComponent } from './generators/addedit-generator/addedit-generator.component';
import { AddeditStreamComponent } from './streams/addedit-stream/addedit-stream.component';
import { AddeditPricematrixComponent } from './pricematrix/addedit-pricematrix/addedit-pricematrix.component';
import { AddeditTotepricematrixComponent } from './totepricematrix/addedit-totepricematrix/addedit-totepricematrix.component';
import { AlertDialogComponent } from '../shared/components/alert-dialog/alert-dialog.component';
import { AddeditChemistryComponent } from './labdata/chemistry/addedit-chemistry/addedit-chemistry.component';
import { AddeditMetalsComponent } from './labdata/metals/addedit-metals/addedit-metals.component';
import { AddExistingStreamComponent } from './streams/add-existing-stream/add-existing-stream.component';
import { RolePermissionsService } from '../../services/role-permissions.service';
import { FilterService } from '../../services/retainFilterControlState.service';
import { MatCardContent, MatCardModule } from "@angular/material/card";
import { RoleService } from '../../services/role.service';
import { LoadScheduleControlFlags, ScreenName } from '../../interfaces/securityPermissions';
@Component({
  selector: 'app-feedstock',
  imports: [MatTabsModule, GeneratorsComponent, StreamsComponent, PricematrixComponent, TotepricematrixComponent, LabdataComponent, FilterControlComponent, MatCardContent, MatCardModule],
  templateUrl: './feedstock.component.html',
  styleUrl: './feedstock.component.scss'
})
export class FeedstockComponent implements OnInit {
  permissions = inject(RolePermissionsService);
  retainFilterService = inject(FilterService);
  activeTabIndex: WritableSignal<number> = signal(0);
  labDataTabIndex: WritableSignal<number> = signal(0);
  public refreshCounter: WritableSignal<number> = signal(0);
  controlPermissions: LoadScheduleControlFlags = new LoadScheduleControlFlags();
  private filterStatesMap = signal<Record<number, FilterState | null>>({});
  private searchQueriesMap = signal<Record<number, string | null>>({});

  public currentFilterState = computed(() => {
    const index = this.activeTabIndex();
    const logicalId = this.getLogicalIdFromPhysicalIndex(index);
    const stateFromMap = this.filterStatesMap()[logicalId];
    if (!stateFromMap) {
      const savedstate = this.retainFilterService.getState(logicalId);
      if(savedstate && savedstate.tabIndex === logicalId){return savedstate;}
      return null;
    }
    const saved = this.retainFilterService.getState(logicalId);
    if (saved && saved.tabIndex === logicalId) {
      return saved;
    }
    
    return {
      tabIndex: logicalId,
      market: -1,
      generator: null,
      stream: null,
      streamid: null,
      searchText: null,
      isWalmart: false
    };
  });
  private getLogicalIdFromPhysicalIndex(index: number): number {
    if (index === 3 && !this.controlPermissions.showToteTab) {
       return 10; // If Tote is hidden, physical index 3 IS Lab Data (ID 10)
    }
    if (index === 4) return 10; // If Tote is visible, physical index 4 IS Lab Data (ID 10)
    return index; // 0, 1, 2 remain the same
  }

  public searchQuery = computed(() => {
    const index = this.activeTabIndex();
    const logicalId = this.getLogicalIdFromPhysicalIndex(index);
    return this.searchQueriesMap()[logicalId] || null;
  });

  constructor(private _dialog: MatDialog, private notificationService: NotificationService,
    private rolesService: RoleService
  ) {    
    this.filterStatesMap.set({0: null, 1: null, 2: null, 3: null, 4: null, 10: null});
    this.searchQueriesMap.set({0: null, 1: null, 2: null, 3: null, 4: null, 10: null});
  }

  ngOnInit(): void {
    let roles = this.rolesService.getRolesAsString();
    this.permissions.getRolePermissionsNew(roles, ScreenName.CustomerInfo, 0).subscribe({
      next: (perms: LoadScheduleControlFlags) => {
        console.log("CustomerInfo permissions ", perms);
        this.controlPermissions = perms;
      }
    })    
  }
  
  handleFilterChange(newFilterState: FilterState): void {
    const index = newFilterState.tabIndex;
  
    this.filterStatesMap.update(states => {
      // 1. Clone the whole map
      const newMap = { ...states };
      // 2. Clone the specific filter object (crucial for signal detection)
      newMap[index] = { ...newFilterState }; 
      return newMap;
    });

    if(newFilterState.searchText !== undefined) {
      this.handleSearchFilterChange(newFilterState.searchText || '', index);
    }
  }

  // handleSearchFilterChange(searchText: string) {    
  //   const index = this.activeTabIndex();

  //   this.searchQueriesMap.update(queries => ({
  //     ...queries,
  //     [index]: searchText
  //   }));
  // }
  handleSearchFilterChange(searchText: string, manualIndex?: number) {    
    // Use the manual index if provided (like 10), otherwise calculate it
    const logicalId = manualIndex ?? this.getLogicalIdFromPhysicalIndex(this.activeTabIndex());
  
    this.searchQueriesMap.update(queries => ({
      ...queries,
      [logicalId]: searchText
    }));
  }

  onTabIndexChange(index: number) {
    this.activeTabIndex.set(index);
    const logicalId = this.getLogicalIdFromPhysicalIndex(index);
    if(logicalId === 10){
      this.labDataTabIndex.set(0);
    }
  }

  
  handleAddClicked(): void {
    const activeIndex = this.getLogicalIdFromPhysicalIndex(this.activeTabIndex());
    const innerIndex = this.labDataTabIndex();
    const currentFilters = this.currentFilterState();

    let dialogComponent: any;
    let saveMsg = 'Customer saved successfully';
    let winName = "Customer";

    if (activeIndex > 0) {
      switch(activeIndex){
        case 1:
          winName = "Stream";
          saveMsg = "Stream saved successfully";
          break;
        case 2:
          winName = 'Price Matrix';
          saveMsg = "Price Matrix saved successfully";
        break;
        case 3:
          winName = "Tote Price Matrix";
          saveMsg = "Tote Price Matrix saved successfully";
        break;
        case 4:
        case 10: // Lab Data when Tote is hidden
          if (innerIndex === 0) {
            winName = "Chemistry";
            saveMsg = "Chemistry lab data saved successfully";
          } else if (innerIndex === 1) {
            winName = "Metals";
            saveMsg = "Metals lab data saved successfully";
          }
        break;
        default:
          console.log("no need");
        break;
      }
      if (!currentFilters || !currentFilters.generator) {
        this._dialog.open(AlertDialogComponent as any, { 
          data: { 
              title: 'Customer Required', 
              message: `Please select a Customer from the <br /> filter controls before adding <br /> a new ${winName} to this tab.`,
              buttonText: 'OK' 
          },
          width: '350px',
          disableClose: true,
          panelClass: 'delete-confirmation-dialog-nowrap'
        });
      return;}
    }
    let ipdata = null;
    switch (activeIndex) {
      case 0: // Generators
        dialogComponent = AddeditGeneratorComponent;
        ipdata = {
          marketId : currentFilters?.market || 0,
          task: 'Add',
          canSave: this.controlPermissions.addCustomer
        };
        break;
      case 1: // Streams
        ipdata = {
          data:{
            generatorId : currentFilters?.generator || 0,
            task: 'Add'
          },
          canSave: this.controlPermissions.addStream,
          isWalmart: currentFilters?.isWalmart === true
        };
        dialogComponent = AddeditStreamComponent;
        break;
      case 2: // Price Matrix
        let showBinRentalFee = currentFilters?.isWalmart === true ? true : false;
        ipdata = {
          genId: currentFilters?.generator || 0,
          streamId: currentFilters?.stream || 0,
          task: 'Add',
          canSave: this.controlPermissions.addPriceMatrix,
          showBinRentalFee: showBinRentalFee,
          showSalesRepAddButton: this.controlPermissions.addSalesRep,
          showSalesRepGridEditButton: this.controlPermissions.editSalesRep,
          showSalesRepGridDeleteButton: this.controlPermissions.deleteSalesRep
        };
        dialogComponent = AddeditPricematrixComponent;
        break;
      case 3: // Tote Price Matrix
        ipdata = {
          genId: currentFilters?.generator || 0,
          streamId: currentFilters?.stream || 0,
          task: 'Add',
          canSave: this.controlPermissions.addTotePriceMatrix,
          showAddButton: true,
          showGridEditButton: true,
          showGridDeleteButton: true
        };
        dialogComponent = AddeditTotepricematrixComponent;
        break;
      case 4: // Lab Data (Assuming no add dialog for this tab)
      case 10: // Lab Data when Tote is hidden
        ipdata = {
          generatorId: currentFilters?.generator || 0,
          streamId: currentFilters?.stream || 0,
          task: 'Add',
          canSave: innerIndex === 0 ? this.controlPermissions.addChemistry : this.controlPermissions.addMetal
        };
        dialogComponent = innerIndex === 0 ? AddeditChemistryComponent : AddeditMetalsComponent;
        break; 
      default:
        console.warn('Unhandled Add action for tab index:', activeIndex);
        break;
    }

    const dialogRef = this._dialog.open(dialogComponent, {
      data: ipdata, // null data means "Add"
      disableClose: true,
      width: '1000px',
      maxWidth: '1050px',
      maxHeight: '90vh'
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(`Successful addition on tab ${activeIndex}. Triggering refresh.`);
        this.refreshCounter.update(count => count + 1);
        this.notificationService.show(saveMsg, 'Success');
      }
    });
  }
  handleExistingStreamsClicked(): void {    
    const activeIndex = this.activeTabIndex();
    const currentFilters = this.currentFilterState();
    if (!currentFilters || !currentFilters.generator) {
      this._dialog.open(AlertDialogComponent as any, { 
        data: { 
            title: 'Customer Required', 
            message: `Please select a Customer from the <br /> filter controls before adding <br /> existing Streams to this tab.`,
            buttonText: 'OK' 
        },
        width: '350px',
        disableClose: true, 
        panelClass: 'delete-confirmation-dialog-nowrap'
      });
      return;
    }else{
      const dialogRef = this._dialog.open(AddExistingStreamComponent, {
        data: { 
          generatorId: currentFilters.generator,
          marketId: currentFilters.market 
        }, // null data means "Add"
        width: '750px',
        disableClose: true,
        maxHeight: '90vh'
      });
      
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          console.log(`Successful addition on tab ${activeIndex}. Triggering refresh.`);
          this.refreshCounter.update(count => count + 1);
        }
      });
    }
  }
}
